export const SET_CREATE_PLAYBOOK_FILTERS = 'SET_CREATE_PLAYBOOK_FILTERS';
export const setCreatePlaybookFilters = (filterData: any) => ({
  type: SET_CREATE_PLAYBOOK_FILTERS,
  payload: filterData,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const createPlaybookFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_CREATE_PLAYBOOK_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
export default createPlaybookFilterReducer;
